import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Col, Row } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import Form from "react-bootstrap/Form";
import OtpInput from "react-otp-input";
import { useMutation } from '@tanstack/react-query';
import { postRequest } from '../services/apiMethods';
import { Formik } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';

function PhoneVerifyModal({ phoneVerifyModal, handlephoneVerifyModalClose ,refetch }) {
  const [counter, setCounter] = useState(30); // 30 sec countdown
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  const { mutate: resendOtpFunc } = useMutation({
    mutationFn: () => postRequest("profile/send-otp"),
    onSuccess: (data) => {
      if (data?.statusCode === 200) {
        // Success logic if needed
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  useEffect(() => {
    let timer;
    if (isResendDisabled && counter > 0) {
      timer = setInterval(() => {
        setCounter(prev => prev - 1);
      }, 1000);
    } else if (counter === 0) {
      setIsResendDisabled(false);
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [counter, isResendDisabled]);

  const handleResendOTP = () => {
    setIsResendDisabled(true);
    setCounter(30);
    resendOtpFunc();
  };

  const validationSchema = Yup.object().shape({
    otp: Yup.string()
      .required("OTP is required")
      .matches(/^\d{6}$/, "OTP must be exactly 6 digits"),
  });



  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
        return postRequest(`/profile/phonenumber-verification`, data);
    },
    onSuccess: (data) => {
      toast.success(`${data?.message}`, {
        iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
        },
        
    })
    window.location.reload();
    handlephoneVerifyModalClose();
    refetch()
    },
    onError: (error) => {
        console.error("Error during API call:", error);
    },
});






  return (
    <Modal show={phoneVerifyModal} onHide={handlephoneVerifyModalClose}>
      <Formik
        initialValues={{ otp: "" }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log("OTP Submitted:", values.otp);
          // Add OTP verify logic here

          if (values) {
            const payload = {
                otp: values.otp
            }
            mutate(payload);
        }

  
        }}
      >
        {({ handleSubmit, setFieldValue, errors, touched, values }) => (
          <>
            <Modal.Body>
              <div className="modal-header-content">
                <h1 className="modal-title">Mobile Phone Verification</h1>
                <p className="modal-description">
                  Enter the 6-digit verification code that was sent to your phone number.
                </p>
              </div>

              <Row>
                <Col lg={12} className="mx-auto">
                  <Form className="cmn-form-set" onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <div className="form-set set-otp mt-3">
                        <OtpInput
                          value={values.otp}
                          onChange={(val) => setFieldValue("otp", val)}
                          numInputs={6}
                          isInputNum
                          inputType="tel"
                          renderInput={(props) => <input {...props} />}
                        />
                      </div>
                      {errors.otp && touched.otp && (
                        <div className="text-danger mt-2">{errors.otp}</div>
                      )}
                    </Form.Group>
                  </Form>
                </Col>
              </Row>

              <div className="resend-otp d-flex justify-content-end">
                <button
                  type="button"
                  onClick={handleResendOTP}
                  disabled={isResendDisabled}
                >
                  {isResendDisabled ? `Resend in ${counter}s` : "Resend OTP"}
                </button>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={handlephoneVerifyModalClose}>
                Close
              </Button>
              <Button variant="primary" onClick={handleSubmit}>
                Verify
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  );
}

export default PhoneVerifyModal;
